import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Sentry from "@sentry/angular-ivy";
import { BrowserTracing } from "@sentry/browser";
import mixpanel from "mixpanel-browser";

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: environment.sentryUrl,
  integrations: [
    new BrowserTracing({
      tracePropagationTargets: [environment.baseUrl],
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
  ],
  tracesSampleRate: 1.0,
});

mixpanel.init("b2512f2fff9e07a83f9fcc0e2121eaf6", {
  track_pageview: true, // Automatically track page views
  persistence: "localStorage", // Persist data in localStorage,
  ignore_dnt:true
});

function bootstrap() {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
